import { paymentClient, Server } from '@wajeez-web/core/api-base';
import {
  thunkErrorHandler,
  thunkResponseCheckerSdk,
} from '@wajeez-web/core/utils';
import { ApiMethod } from '@wajeez-web/stores/base';

export const createBehaviourEvent: ApiMethod<
  Server.CreateBehaviourEventInput,
  number,
  void
> = async (body, { dispatch, rejectWithValue }) => {
  return thunkErrorHandler(
    async () => {
      return thunkResponseCheckerSdk(async () => {
        const client = new Server.Server_BehaviourEvent_Client(
          undefined,
          paymentClient
        );

        return client.behaviourEvent_post_V1(body);
      }, rejectWithValue);
    },
    dispatch,
    rejectWithValue
  );
};
